export default __webpack_public_path__ + "static/media/riskometer-icon.7f388415.svg";